<template>
  <div class="core">
    <div class="layui-fluid">
      <pub-search :search-type="'add'" :tableObj="tableObj" :searchConfig="searchConfig" exportTemplate="品牌表.xlsx">
        <template>
          <button class="layui-btn" title="新增品牌" @click="add()">
            <i class="layui-icon">&#xe624;</i>
            新增品牌
          </button>
          <!--              <button class="layui-btn" title="导入" @click="importExcel()" v-if="true">-->
          <!--                <span style="display:none" id="importWarpper">-->
          <!--                  <form enctype="multipart/form-data" style="margin-top: 20px;margin-bottom:10px;">-->
          <!--                      <div style="margin-left: 8.33333333%;">-->
          <!--                          <input type="file" id="file" accept=".xls,.xlsx"/>-->
          <!--                          <font color="red" style="margin-top:10px;display: block;">-->
          <!--                            提示：仅允许导入“xls”或“xlsx”格式文件！-->
          <!--                          </font>-->
          <!--                      </div>-->
          <!--                  </form>-->
          <!--                </span>-->
          <!--                <i class="layui-icon">&#xe624;</i>-->
          <!--                导入-->
          <!--              </button>-->
        </template>
      </pub-search>
      <layui-table
        ref="brand"
        table-name="YW_CUSTOMER_BRAND"
        view-name="YW_BRAND_DETAIL_V"
        :page-size="20"
        :page-range="6"
        :page-options="[10, 20, 50, 100]"
        :skin="'line'"
        :slave-tables="['YW_CUSTOMER_STORE']"
        :sort="['CREATE_TIME:DESC']"
        @table-event-edit="edit($event)"
        @table-event-check="check($event)"
        @table-event-del="$refs.brand.delRows($event.data)"
      >
        <div>
          <div checkbox="true" align="center" fixed="left" width="60"></div>
          <!-- <div title="序号" width="60"  fixed="left" field="_NUMBER" align="center"></div> -->
          <layui-tableconfig :config="brandTableList"></layui-tableconfig>
          <div align="center" fixed="right" title="操作" width="130">
            <script type="text/html" v-pre>
              <a class=" layui-btn-xs" lay-event="check" style="cursor:pointer">查看</a>
              <a class=" layui-btn-xs" lay-event="edit"  style="cursor:pointer">编辑</a>
              <a class="layui-btn-xs layui-btn-xs-danger" lay-event="del"  style="cursor:pointer">删除</a>
            </script>
          </div>
        </div>
      </layui-table>
    </div>
    <brandForm v-if="brandFormShow" :visible.sync="brandFormShow" :formType="brandFormType" :formData="brandFormData" />
  </div>
</template>
<script>
import '../../../utils/map/css/core.css'
import brandForm from './brandForm'

export default {
  name: 'brand',
  components: {
    brandForm
  },
  data() {
    return {
      brandTableList: [
        { field: 'BRAND_BH', title: '品牌编码', sort: true, width: 150 },
        { field: 'BRAND_NAME', title: '品牌名称', width: 300 },
        { field: 'CLIENT_NAME', title: '客户名称', width: 200 },
        { field: 'MANAGER_NAME', title: '项目经理', width: 150, sort: true },
        { field: 'PERSON_NAME', title: '联系人姓名', width: 150 },
        { field: 'PERSON_PHONE', title: '联系人电话', width: 150 },
        { field: 'BALANCE_TYPE_DESC', title: '结算类型', width: 150 },
        { field: 'BALANCE_DATE', title: '结算周期', width: 253 },
        { field: 'BRAND_DESCRIBE', title: '描述', width: 253 },
        { field: 'SLA_CLUB', title: 'SLA等级', width: 150 },
        { field: 'OVER_TIME_HOUR', title: '超时时间(h)', width: 150 },
        { field: 'CREATE_TIME', title: '创建时间', width: 180 }
      ],
      brandFormShow: false,
      brandFormType: null,
      brandFormData: null,
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
      searchConfig: {
        basic: [
          // { TYPE:'input', WIDTH: 260, FIELD: 'BRAND_BH:2,BRAND_NAME:2,CLIENT_NAME:2,PERSON_NAME:2,PERSON_PHONE:2,CREATE_TIME:2,', PLACEHOLDER: '请输入查询条件'},
          {
            TYPE: 'input',
            WIDTH: 260,
            FIELD: 'BRAND_BH:2,BRAND_NAME:2,CLIENT_NAME:2,PERSON_NAME:2,PERSON_PHONE:2',
            PLACEHOLDER: '请输入查询条件'
          }
        ],
        advanced: [
          { TYPE: 'input', NAME: '品牌编码 :', FIELD: 'BRAND_BH:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '品牌名称 :', FIELD: 'BRAND_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '客户名称 :', FIELD: 'CLIENT_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '项目经理 :', FIELD: 'MANAGER_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '联系人姓名 :', FIELD: 'PERSON_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '联系人电话 :', FIELD: 'PERSON_PHONE:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'date', NAME: '创建时间 :', FIELD: 'CREATE_TIME:2' }
        ],
        showBatch: true
      }
    }
  },
  watch: {
    brandFormShow: function(newVal) {
      if (this.baseComponent && newVal === false) {
        if (this.tabParam) {
          this.baseComponent.closeComponent(this.tabParam.cloneMenu)
          if (this.tabParam.from == 'storeForm') {
            this.baseComponent.currentComponent = this.tabParam.sourceMenu
          }
        }
      }
    }
  },
  mounted() {
    this.tableObj = this.$refs.brand
    if (this.tabParam) {
      this.brandFormShow = true
      this.brandFormType = 'add'
    }
  },
  methods: {
    /**
     * 新增品牌
     */
    add() {
      this.brandFormShow = true
      this.brandFormType = 'add'
    },
    /**
     * 编辑
     */
    edit($event) {
      this.brandFormType = 'edit'
      var data = $event.data
      this.brandFormData = data
      this.brandFormShow = true
    },
    check($event) {
      this.brandFormType = 'browser'
      var data = $event.data
      this.brandFormData = data
      this.brandFormShow = true
      // this.baseComponent.smartLoadComponent('serviceForm', {editRow: $event.data, tableObj: this.tableObj, formType: 'browser', title: '查看服务商'})
    },
    importExcel() {
      var that = this
      this.layui.layer.open({
        type: 1,
        area: ['400px', '230px'],
        fix: false,
        //不固定
        maxmin: true,
        shade: 0.3,
        title: '上传数据',
        content: $('#importWarpper').html(),
        btn: ['<i class="fa fa-check"></i> 导入', '<i class="fa fa-remove"></i> 取消'],
        // 弹层外区域关闭
        shadeClose: true,
        btn1: function(index, layero) {
          var file = layero.find('#file').val()
          if (file == '' || (!file.endsWith('.xls') && !file.endsWith('.xlsx'))) {
            that.layer.openAlert('请选择后缀为 “xls”或“xlsx”的文件。')
            return false
          }
          var index = layer.load(2, { shade: false })
          var formData = new FormData()
          formData.append('file', layero.find('#file')[0].files[0])
          $.ajax({
            url: process.env.API_HOST + '/historyData/import/brand?token=' + that.security.getToken(),
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function(result) {
              layer.closeAll()
              if (result.errorMsg) {
                that.layer.openAlert(result.errorMsg)
                return
              }
              result = result.result
              layer.close(index)
              if (result != '') {
                that.$nextTick(() => {
                  that.tableObj.load()
                })
              }
            },
            error: function(err) {
              layer.close(index)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/person/brandManage/index.vue